var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRootControlSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.912109 0.0639648C0.912109 0.0639648 0.915372 0.830641 1.00389 2.06396C1.36619 7.11216 3.15682 19.9786 11.9984 20.0882C20.8546 20.1981 22.5816 7.15511 22.9184 2.06396C23 0.830641 23 0.0639648 23 0.0639648H0.912109ZM3.00927 2.06396C3.03055 2.34706 3.05646 2.65424 3.08802 2.98177C3.26108 4.77812 3.59986 7.14297 4.25561 9.48586C4.91801 11.8525 5.86398 14.05 7.16717 15.6286C8.42392 17.1509 9.97074 18.0629 12.0232 18.0884C14.0587 18.1136 15.5797 17.2392 16.8174 15.7424C18.1068 14.1832 19.0427 11.9845 19.6958 9.59914C20.3418 7.23956 20.6708 4.84915 20.8363 3.03059C20.8678 2.68463 20.8933 2.36097 20.9138 2.06396H3.00927Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.036 7.55143C7.66593 7.54655 3.18612 5.46622 1.56761 1.19588L2.5027 0.841474C3.92564 4.59582 7.92635 6.54684 12.0371 6.55143C16.1474 6.55603 20.1475 4.61449 21.5711 0.84202L22.5067 1.19509C20.8876 5.48546 16.4065 7.55632 12.036 7.55143Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootControlSimple);
export default __webpack_public_path__ + "static/media/root-control-simple.ff01f0ea.svg";
export { ForwardRef as ReactComponent };